/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://itzqi5u7k3.execute-api.us-east-2.amazonaws.com/kemproyal",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://fotfjenplzfudcurhzlewrmmr4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-d7wx72amebchvctcdyll3yco6e",
    "aws_cognito_identity_pool_id": "us-east-2:25b1f647-12c5-44f3-a569-49c186c4b0e9",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_pHGXWSVSR",
    "aws_user_pools_web_client_id": "5v6tsldd5bb4bingi3i8i6vj5b",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
